import { applyMiddleware, compose, createStore } from 'redux';
// import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
// eslint-disable-next-line import/no-extraneous-dependencies
import freeze from 'redux-freeze';
import createSagaMiddleware from 'redux-saga';
import reducers from './core/reducers';
import sagas from './core/sagas';
import { isDev } from './utils/development/tools';

const devMode = isDev();

// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = devMode ? (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose) : compose;
const sagaMiddleware = createSagaMiddleware();

const middleware = [
  sagaMiddleware,
];

if (devMode) {
  middleware.push(freeze);
}

export const store = createStore(
  reducers,
  composeEnhancers(applyMiddleware(...middleware)),
);

// TODO Review the aggregation of all the sagas, something is not configured properly
sagaMiddleware.run(sagas);

export default store;
